import {
  BASE_URL,
  CONDITION,
  CONDITION_DATA,
  ERROR_MSG,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchConditionData = async (
  pageNo,
  recordsPerPage,
  urlWithParams
) => {
  let response = await fetch(
    `${BASE_URL}${CONDITION_DATA}/${pageNo}/${recordsPerPage}?${urlWithParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );

  return response;
};

export const fetchConditions = async () => {
  let response = await fetch(`${BASE_URL}${CONDITION}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });

  return response;
};

export const addNewCondition = async (form) => {
  let response = await fetch(`${BASE_URL}${CONDITION}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    let error = await response.json();
    return error;

  }
};

export const fetchConditionById = async (conditionId) => {
  let response = await fetch(`${BASE_URL}${CONDITION}/${conditionId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const updateConditionRecord = async (form) => {
  let response = await fetch(`${BASE_URL}${CONDITION}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(form),
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    let error = await response.json();
    return error;
  }
};

export const removeConditionRecord = async (conditionId) => {
  let response = await fetch(`${BASE_URL}${CONDITION}/${conditionId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (!response.ok) {
    return ERROR_MSG;
  }
};
